import { gql } from 'apollo-angular';

export const Query_GetLostEquipmentDetails = gql`
  query getLostEquipmentDetails(
    $filter: DtoEquipmentCountingJournalMetricsFilter
  ) {
    getLostEquipmentDetails(filter: $filter) {
      totalCount
      totalBookValue
      totalReplacementCost
      avgAge
      byLocation {
        locationNum
        locationName
        totalCount
        totalBookValue
        totalReplacementCost
        categories {
          category
          count
          bookValue
          replacementCost
        }
      }
      byCategory {
        category
        count
        bookValue
        replacementCost
      }
    }
  }
`;
